var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articleStory-top--governmentStyle"},[_c('h3',{staticClass:"articleStory-title--governmentStyle"},[_vm._v(_vm._s(_vm.info.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }